module.exports = __webpack_public_path__ + "img/s12.9dc5622.png";